import { Injectable } from '@angular/core';
import { AuthTypes } from '../../core-modules/constant';

@Injectable()
export class RegistrationFeeTokenService {
  // public registrationToken: any = 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6IjVhNjA2NWRhOGEwM2Y2OTJjMDI3NWVjNCIsImlhdCI6MTUxNjM2NzY4MSwiZXhwIjoxNTE4OTU5NjgxfQ.wpIbRfqFi8uM8NIZ79uShIjzdlcGy0419D_o9zBOfw0';
public registrationToken: any = false;
  constructor() { }
tokenPrefix

  setRegistrationToken(token) {
    this.registrationToken = token;
    return true;
  }
  getRegistrationToken() {
    return AuthTypes.tokenPrefix+this.registrationToken;
  }

}



// WEBPACK FOOTER //
// /usr/share/nginx/grade5_live/grade5-frontend-2.0/src/app/shared/services/registration-fee-token.service.ts